import { defineMessages } from 'react-intl';

export default defineMessages({
  switchToManualInput: {
    id: 'geoSuggest.switchToManualInput',
    defaultMessage: 'Cant find your address?  Enter it here.',
  },
});
